import axios from "axios";

export default {
  
    data: () => ({
        phone : "",
        otp : "",
        pk : "",
        show_otp : false
    }),
  
    mounted() {
    
    },
  
    methods:{
    async signup() {
        if (!this.phone || this.phone.length !== 11 ) {
            this.$store.commit('snackbar', { color: 'red', text: 'شماره همراه معتبر وارد کنید.' })
        }
        else{
            this.$store.commit('progress_status', true)
            await axios({
                method: "POST",
                url: "/sign-up",
                // headers: {
                //     token: sessionStorage.getItem("token") || localStorage.getItem("token")
                // },
                data: {
                    phone: this.phone
                }
            })
                .then((res) => {
                    console.log(res.data);
                    this.pk = res.data.pk
                    this.show_otp = true
                })
                .catch((err) => {
                    console.log(err);
                    if (err.message ===
                        "Network Error") {
                        this.$store.commit('snackbar', { color: 'red', text: 'مشکلی در اتصال به اینترنت پیش آمده' })
                    }
                })
                .finally(() => {
                    this.$store.commit('progress_status', false)
                });
        }
     },
     async signin() {
        this.$store.commit('progress_status', true)
        await axios({
            method: "POST",
            url: "/sign-in",
            // headers: {
            //     token: sessionStorage.getItem("token") || localStorage.getItem("token")
            // },
            data: {
                otp: this.otp,
                pk: this.pk,
            }
        })
            .then((res) => {
                // console.log(res.data);
                sessionStorage.setItem("token" , res.data.token)
                this.$router.push('/home')
            })
            .catch((err) => {
                console.log(err);
                if (err.message ===
                    "Network Error") {
                    this.$store.commit('snackbar', { color: '#D50000', text: 'مشکلی در اتصال به اینترنت پیش آمده' })
                }
            })
            .finally(() => {
                this.$store.commit('progress_status', false)
            });
     },
    }
  };